import React, { Fragment } from 'react';
import { Grid, Divider, Image, Button } from 'semantic-ui-react';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import LinkButton from '../UtilityComponents/LinkButton';
import withFullScreenLoader from '../UtilityComponents/withFullScreenLoading/index';
import withDataFetch from '../../api/withDataFetch';
import ExternalLinkButton from '../UtilityComponents/ExternalLinkButton';
import preventiePDF from '../../assets/pdfs/preventie.pdf';

import './Services.css';
import SpacedParagraph from '../UtilityComponents/SpacedParagraph/index';

const Services = ({
  data: {
    title,
    subtitle,
    paragraph,
    paragraph1,
    image: { url: image },
    subtitle1,
    paragraph2,
    image1: { url: image1 },
    buttontext: buttonText,
  },
}) => {
  return (
    <Grid stackable className="Services">
      <Grid.Row columns="equal" centered>
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />

      <Grid.Row>
        {renderDataAsHtml(subtitle)}
      </Grid.Row>
      <Grid.Row columns="two">
        <Grid.Column width={10}>
          {renderDataAsHtml(paragraph)}
          <Fragment>
            <LinkButton link="/klinieken" text="Onze klinieken" />
            <LinkButton link="/tarieven" text="Tarievenlijst" />
          </Fragment>
          <SpacedParagraph text={renderDataAsPlainText(paragraph1)} />
          <LinkButton link="/contact" text="Contact" />
        </Grid.Column>
        <Grid.Column width={6}>
          <Image centered rounded fluid src={image} />
        </Grid.Column>
      </Grid.Row>
      <Divider />

      <Grid.Row>
        <Grid.Column width="10">
          {renderDataAsHtml(subtitle1)}
          {renderDataAsHtml(paragraph2)}
          <a href={preventiePDF} download className="Prevention__Download">
            <Button className="btn-animated">
              {renderDataAsPlainText(buttonText)}
            </Button>
          </a>
          <SpacedParagraph text="Om het document te openen heeft u mogelijks Adobe Acrobat Reader nodig." />
          <ExternalLinkButton
            link="https://acrobat.adobe.com/nl/nl/acrobat/pdf-reader.html"
            text="Download Adobe Acrobat hier"
          />
        </Grid.Column>
        <Grid.Column width="6">
          <Image centered rounded fluid src={image1} />
        </Grid.Column>
      </Grid.Row>
      <Divider />
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoader(Services), 'diensten');



// WEBPACK FOOTER //
// ./src/components/Services/index.js